export default {
    top_menu: [
        {name:'Itthon',    id:0},
        {name:'Show biznisz', id:1},
        {name:'Főzés',  id:2},
        {name:'Politika',   id:3},
        {name:'Pikáns',  id:4},
        {name:'Társadalom',   id:5},
        {name:'Egészség',   id:6},
    ],
    read_other: 'Olvass mást',
    read_more:  'Olvass tovább',
    not_found:  'Nem található',
    read_also:  'Olvassa el is',
    copy_rights: 'Szerzői jog © 2019 «mixer-novostei.ru». Minden jog fenntartva.',
    subscribe: 'Iratkozz fel',

    thank_order: 'KÖSZÖNJÜK A RENDELÉST',
    specialist_contact: 'Szakértőnk hamarosan felveszi Önnel a kapcsolatot, várja hívását',
    attention: 'Figyelem',
    we_value_customers: 'Nagyra értékeljük minden vásárlónkat, ezért szeretnénk Önnek is különleges termékeket kínálni akciós áron, csak az Ön számára.',
    hurry: 'Siess, a kedvezmény aktiválási ideje korlátozott! Neked csak <span id="time" class="time">30:00</span> perc, hogy válasszon egyet ezen egyedi termékek közül:',

    hour_ago1: "egy órával ezelőtt",
    hour_ago2: "egy órával ezelőtt",
    hour_ago3: "egy órával ezelőtt",
    new_publications: "Új bejegyzések",
    read: "Olvas",
    today_at: "Ma be",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "Legfontosabb hírek",
    leave_already: "Már indul? Várja meg a frissített híreket",
    already_shared: "már megosztott"

}